// This file is not yet translated.
/* eslint-disable i18next/no-literal-string */
import { Box, Typography } from "@outschool/backpack";
import { useFeatureFlag } from "@outschool/ui-components-shared";
import React from "react";

import TempMathImage from "../../../../images/category/math.jpg";
import TempScienceImage from "../../../../images/category/scienceAndNature.jpg";
import HeroLayoutWithTabs from "../../layout/HeroLayoutWithTabs/HeroLayoutWithTabs";
import { learnerRoutes } from "../../lib/Routes";
import { NotFoundPage } from "../NotFoundPage";
import MixTopicCard from "./MixTopicCard";

const DUMMY_TOPICS = [
  {
    title: "Math",
    imageUrl: TempMathImage,
    isDefault: true,
    isSelected: true,
  },
  {
    title: "Environmental Arts",
    imageUrl: TempScienceImage,
    isDefault: false,
    isSelected: false,
  },
];

export default function LearnerDiscovery() {
  const isMixUpEnabled = useFeatureFlag("nav-pod-mix-up-machine");
  if (!isMixUpEnabled) {
    return <NotFoundPage />;
  }

  return (
    <HeroLayoutWithTabs currentPath={learnerRoutes.discoveryPath()}>
      <Box
        flex
        sx={{
          flexDirection: "column",
          marginTop: "1.5rem",
        }}
      >
        <Typography variant="h2">The Mix-Up Machine</Typography>
        <Typography
          variant="body1"
          sx={{ color: "grey.600", marginTop: "1rem" }}
        >
          Select 2 topics and mix them to explore your interests.
        </Typography>
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            gap: "20px",
            marginY: "2em",
          }}
        >
          {DUMMY_TOPICS.map(topic => (
            <MixTopicCard
              key={topic.title}
              title={topic.title}
              imageUrl={topic.imageUrl}
              isDefault={topic.isDefault}
              isSelected={topic.isSelected}
              // TODO: feed into the mixer on click
              onCardClick={() => {}}
              // TODO: render modal on button click
              onButtonClick={() => {}}
            />
          ))}
        </Box>
      </Box>
    </HeroLayoutWithTabs>
  );
}
